import React from "react";
import { useMotExpired } from "./useMotExpired";

export const MotExpired = ({ now }) => {
  const { isMotExpired, daysFromNow, offeredValuation } = useMotExpired(now);
  return (
    <>
      <div className="ch-display--flex ch-flex-flow--column-wrap ac-dbq--light-blue-alert ch-pv--3 ch-ph--2">
        <p className="ch-centered ch-text--center ch-fw--500 ch-mb--0 ch-fs--3">
          Your MOT{" "}
          {isMotExpired
            ? "has expired"
            : `is due to expire in ${daysFromNow} day${daysFromNow > 1 ? "s" : ""}.`}{" "}
        </p>
        <p
          className="ch-text--center ch-mb--0 ch-fs--2 mot-lh-24"
          data-testid="mot-expired-text"
        >
          Your valuation would increase to{" "}
          <span className="ch-text--bold">
            £{offeredValuation?.toLocaleString()}{" "}
          </span>
          with an MOT valid for more than 30 days.
        </p>
      </div>
    </>
  );
};
